---
title: Claim Your Username on Entire
description: If you’re an authenticated user of a GitHub account, you can claim that same handle on Entire starting today to keep the same name across platforms.
ogDescription: ""
category: Company
author: Lizzie Siegle
featureImage: /blog/claim-your-username-on-entire/header-3840x2160.png
featureImageAlt: "Entire is opening up: Claim your username"
hideFeatureImage: true
image: /blog/claim-your-username-on-entire/header-3840x2160.png
imageWidth: 3840
imageHeight: 2160
---

![Claim your username](/blog/claim-your-username-on-entire/header-3840x2160.png)

**The time has come for a transition to a new Git forge, but that doesn’t mean you can’t keep your current GitHub handle.** If you’re an authenticated user of a GitHub account, you can claim that same handle on Entire starting today to keep the same name across platforms.

Your username on Entire is how you are displayed and tagged on the platform, for example when assigning a Trail to you. For repos, Entire currently uses two namespaces:

1. `/gh/` holds mirrors of GitHub repos. These always match your GitHub slug, for example, [github.com/entireio/cli](http://github.com/entireio/cli) automatically becomes [entire.com/gh/entireio/cli](http://entire.com/gh/entireio/cli).
2. `/et/` holds native Entire repos. In contrast to GitHub, your username or organization name do not go into the slug here. Instead `/et/` is followed by your project/repo name. We created a block list for popular projects, so their names can only be reserved by [contacting us](mailto:support@entire.io).

<CloudflareStreamVideo
  videoId="df9d9bf3d94ff51074a946000f9af928"
  title="Claim Your Username on Entire"
  aspectRatioPercent="56.25%"
  loop
/>

We're opening username claims in two phases. From now until end of 2026, you can claim your GitHub username to become your Entire username. Beginning in 2027, it will be a free-for-all to claim _any_ available username.

Here’s how you can sign up for your GitHub username:

1. Sign in to Entire with GitHub (so we know the handle is really yours).
2. Open your [Account settings](https://entire.com/account) and find the username section.
3. Claim the name that matches your GitHub login.

Any issues, flags, or existential angst? [Let us know on Discord today](https://discord.gg/j52yQmgT8).
